import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import Progress from '../ui/react-ui/progress.jsx';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
import Input from '../ui/input';
import Textarea from '../ui/textarea'; // Api

import { editDataInterfaceAPI } from '../../api/interfaceAPI'; // Redux

import { clearDialogInfo } from '../../redux/setting-service';
var t = i18n.getFixedT(null, 'setting-service');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var InterfaceEdit = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      dialogInfo = _useSelector.service.dialogInfo;

  var dispatch = useDispatch();

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      formData = _useState2[0],
      setFormData = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var id = props.id,
      onClose = props.onClose;
  var form_ref = useRef(null);

  var handleClose = function handleClose() {
    dispatch(clearDialogInfo());
    setFormData({});
  };

  var handleChange = function handleChange(list) {
    setFormData(list);
  };

  var handeChangeInputValue = function handeChangeInputValue(val, path) {
    var newData = _.cloneDeep(formData);

    var value = path === 'retryInterval' ? formatSecToHms(val) : val;

    _.set(newData, "schedule.".concat(path), value);

    handleChange(newData);
  };

  var handleChangeTextarea = function handleChangeTextarea(val) {
    var newData = _.cloneDeep(formData);

    _.set(newData, "description", val);

    handleChange(newData);
  };

  var handleConfirm = function handleConfirm() {
    Progress.startSpin();
    editDataInterfaceAPI(contextRoot, true, formData).then(function (result) {
      setFormData({});
      onClose();
    }).catch(function (error) {
      Progress.done();
      setError(error.message);
    });
  };

  var formatHmsToS = function formatHmsToS(time) {
    return moment.duration(time).as('seconds');
  };

  var formatSecToHms = function formatSecToHms(secs) {
    return moment().startOf('day').seconds(secs).format('HH:mm:ss');
  };

  useEffect(function () {
    setFormData(dialogInfo.data);
  }, []);
  if (_.isEmpty(formData)) return null;
  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: handleClose
  });

  _.set(actions, 'confirm', {
    text: gt('global.lbl-answer-ok'),
    className: 'button-success',
    // disabled: !formValid,
    handler: handleConfirm
  });

  var fields = {};

  _.set(fields, 'name', {
    label: t('lbl-interface-info-id')
  });

  _.set(fields, 'sourceType', {
    label: t('lbl-source-type'),
    formatter: function formatter(val, row) {
      return t("lbl-".concat(val.toUpperCase()));
    }
  });

  _.set(fields, 'category', {
    label: t('dlg-category')
  });

  _.set(fields, 'system', {
    label: t('dlg-system'),
    editor: Input,
    props: {// required: true,
      // validate: {
      //     t: code => {
      //         return et(`txt-${code}`)
      //     }
      // }
    }
  });

  _.set(fields, 'description', {
    label: t('lbl-description'),
    editor: null,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Textarea // validate={{
      //     required: true,
      // }}
      , {
        onChange: function onChange(val) {
          return handleChangeTextarea(val);
        },
        value: val
      }));
    }
  });

  if (formData.sourceType === 'HttpApi') {
    _.set(fields, 'uri', {
      label: t('dlg-interface-url'),
      editor: Input,
      props: {// required: true,
        // validate: {
        //     t: code => {
        //         return et(`txt-${code}`)
        //     }
        // }
      }
    });

    _.set(fields, 'cronExpression', {
      label: t('dlg-interface-duration'),
      editor: null,
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement(Input, {
          value: row.schedule ? row.schedule.cronExpression : '' // validate={{
          //     required: true,
          //     pattern: /^[0-9]*$/,
          //     t: code => et('txt-not-int')
          // }}
          ,
          onChange: function onChange(val) {
            return handeChangeInputValue(val, 'cronExpression');
          }
        });
      }
    });

    _.set(fields, 'retryInterval', {
      label: t('dlg-retry-interval'),
      editor: null,
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement(Input, {
          value: row.schedule ? formatHmsToS(row.schedule.retryInterval) : '',
          validate: {
            // required: true,
            pattern: /^[0-9]*$/,
            t: function t(code) {
              return et('txt-not-int');
            }
          },
          onChange: function onChange(val) {
            return handeChangeInputValue(val, 'retryInterval');
          }
        });
      }
    });

    _.set(fields, 'retryTimes', {
      label: t('dlg-retry-times'),
      editor: null,
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement(Input, {
          value: row.schedule ? row.schedule.retryTimes : '',
          validate: {
            // required: true,
            pattern: /^[0-9]*$/,
            t: function t(code) {
              return et('txt-not-int');
            }
          },
          onChange: function onChange(val) {
            return handeChangeInputValue(val, 'retryTimes');
          }
        });
      }
    });
  }

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('dlg-interface'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: handleChange,
    value: formData
  }));
});
InterfaceEdit.defaultProps = {
  id: 'g-interface-edit'
};
InterfaceEdit.propTypes = {
  id: PropTypes.string
};
export default InterfaceEdit;